import React from "react";
import "./../../UaeAttestation/UaeReq/UaeReq.css";

const ChinaReqMain = () => {
  return (
    <div className="uaeReqMainContainer">
      <div className="uaeReqMainContent">
        <h3>Requirement of China Attestation:</h3>
        <p>
          Embassy certificate attestation is obligatory for China visas. If
          you are applying for an employment visa or have got an employment
          offer from Bahrain, you are required to submit important documents for
          certification.The certificate attestation for China visa is needed for
          several causes such as student visa, work visa, residence visa, or for
          business aspects. It is a part of the evidence that shows that you are
          a legitimate person or company. It proves that your certificates are
          genuine & can be permitted in the nation.
        </p>
      </div>
      <div className="uaeReqMainContent">
        <h3>Total time-span to get China Certificate Attestation:</h3>
        <p>
          The total time needed for certificate attestation for China is based
          on several aspects such as which country you required the legalization
          for, or the types of documents, or the authority you need it from.
          Generally, it will take around 15 days to 25 days to accomplish the
          whole process.
        </p>
      </div>
    </div>
  );
};

export default ChinaReqMain;
